function injectStyle (ssrContext) {
  require("!!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\extract-text-webpack-plugin\\dist\\loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\style-compiler\\index?{\"vue\":true,\"id\":\"data-v-551f520f\",\"scoped\":true,\"hasInlineConfig\":false}!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\selector?type=styles&index=0!./propaganda.vue")
  require("!!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\extract-text-webpack-plugin\\dist\\loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\style-compiler\\index?{\"vue\":true,\"id\":\"data-v-551f520f\",\"scoped\":false,\"hasInlineConfig\":false}!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\selector?type=styles&index=1!./propaganda.vue")
}
var normalizeComponent = require("!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\component-normalizer")
/* script */
export * from "!!babel-loader!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\selector?type=script&index=0!./propaganda.vue"
import __vue_script__ from "!!babel-loader!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\selector?type=script&index=0!./propaganda.vue"
/* template */
import __vue_template__ from "!!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\template-compiler\\index?{\"id\":\"data-v-551f520f\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!D:\\ADO_CICD\\tools\\nodejs\\portal\\node_modules\\vue-loader\\lib\\selector?type=template&index=0!./propaganda.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-551f520f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/secondary/propaganda.vue
// module id = null
// module chunks = 